import React from "react";
import LikeButton from "./LikeButton";

function SocialShare({ url, title, image, postId }) {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedImage = encodeURIComponent(image || "");

  return (
    <div className="hidden lg:block  mr-8 sticky top-32 text-gray-600">
	    <div className="sticky top-20 space-y-4 flex flex-col rounded-full bg-slate-50 px-3 py-5">
           <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="share on facebook"
        className="hover:text-blue-600"
      >
        <i className="bx bxl-facebook text-xl"></i>
      </a>
      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="share on twitter"
        className="hover:text-blue-400"
      >
        <i className="bx bxl-twitter text-xl"></i>
      </a>
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="share on linkedin"
        className="hover:text-blue-700"
      >
        <i className="bx bxl-linkedin text-xl"></i>
      </a>
      <a
        href={`https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="share on pinterest"
        className="hover:text-red-600"
      >
        <i className="bx bxl-pinterest text-xl"></i>
      </a>
      <a
        href={`mailto:?subject=${encodedTitle}&body=${encodedUrl}`}
        aria-label="share by email"
        className="hover:text-green-600"
      >
        <i className="bx bx-envelope text-xl"></i>
      </a>
	    </div>
    </div>
  );
}

export default SocialShare;